/**
 * Deliberately import-free: main.ts loads this before @/bootstrap, so anything
 * imported here would be evaluated before jQuery and the stores exist.
 */
export const trans = (key: string, locale: string | null = null): string => {
  const i18n = window.i18n?.[(locale ?? 'nl').split('_')[0]]

  if (!i18n) return key

  const parts = key.split('.').map(part => part.toLowerCase())
  const value = parts.reduce<any>((carry, part) => carry?.[part], i18n)
  const fallback = i18n.general?.[parts.at(-1)!]
  const translation = typeof value === 'string' ? value : typeof fallback === 'string' ? fallback : undefined

  if (!translation) return key

  return /^[A-Z]/.test(key) ? translation.charAt(0).toUpperCase() + translation.slice(1) : translation
}

// Global alias for blade and other non-module callers; modules import trans directly.
window.trans = trans
